export default [
  {
    name: 'English',
    flag: 'us',
    file: 'en-US.ts',
    code: 'en',
    rtl: false
  },
  {
    name: 'Français',
    file: 'fr-CA.ts',
    flag: 'fr',
    code: 'fr',
    rtl: false
  },
  {
    name: 'עברית',
    file: 'he-IL.ts',
    flag: 'il',
    code: 'he',
    rtl: true
  }
]
